// react
import React from 'react';
import ReactDOM from 'react-dom/client';

// tanstack
import { RouterProvider } from '@tanstack/react-router';

// components
import { setHighchartsLanguage } from '@/i18n/highchartsLocalization.ts';

// relative
import MuiXLicense from './components/MuiXLicense/MuiXLicense.jsx';

// fonts
import '@fontsource-variable/manrope';

import './index.css';
import i18n, { initI18n } from './i18n/i18n.ts';
import { setAccountIdResolver } from './redux/accountContext.ts';
import { ReduxProvider } from './redux/ReduxProvider.tsx';
import { router } from './router.ts';
// Import the generated route tree
import { setRuntimeConfig } from './runtimeConfig.js';
// Run this once before initializing any charts

import Highchart from 'highcharts';
(function (H) {
  const originalNumberFormat = H.numberFormat;

  H.numberFormat = function (number, decimals, decimalPoint, thousandsSep) {
    // If decimals is undefined or null (-1), apply your global default (e.g., 2)
    const defaultDecimals = 2;
    const targetDecimals =
      decimals === undefined || decimals === null || decimals === -1
        ? defaultDecimals
        : decimals;

    return originalNumberFormat(
      number,
      targetDecimals,
      decimalPoint,
      thousandsSep,
    );
  };
})(Highchart);
setHighchartsLanguage(i18n.language);
i18n.on('languageChanged', setHighchartsLanguage);

async function bootstrap() {
  let runtimeConfig = {};
  try {
    const response = await fetch('/runtime-config');
    if (response.ok) {
      runtimeConfig = await response.json();
    }
  } catch {
    // Continue with defaults if runtime config is unavailable
  }

  setRuntimeConfig(runtimeConfig);
  initI18n(runtimeConfig.translationsUrl);

  const root = ReactDOM.createRoot(document.getElementById('root'));

  setAccountIdResolver(() => {
    return router.state.matches
      .map((match) => match.params)
      .find((params) => 'accountId' in params)?.accountId;
  });

  root.render(
    <React.StrictMode>
      <ReduxProvider>
        <RouterProvider router={router} />
        <MuiXLicense />
      </ReduxProvider>
    </React.StrictMode>,
  );
}

bootstrap();
